// src/routes/AppRoutes.js
import React from 'react';
import { Routes, Route} from 'react-router-dom';
import PublicRoutes from './PublicRoutes';
import AuthRoutes from './AuthRoutes';
import PatientRoutes from './PatientRoutes';
import DoctorRoutes from './DoctorRoutes';
import HospitalRoutes from './HospitalRoutes';
import PharmacyRoutes from './PharmacyRoutes';
import AdminRoutes from './AdminRoutes';
import SharedRoutes from './SharedRoutes';
import AmbulanceRoutes from './AmbulanceRoutes';
import DashboardRedirect from '../components/auth/DashboardRedirect';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Dashboard Redirect - redirects to appropriate dashboard based on user role */}
      <Route path="/dashboard" element={<DashboardRedirect />} />
      
      {/* Auth Routes */}
      <Route path="/auth/*" element={<AuthRoutes />} />
      
      {/* Patient Routes */}
      <Route path="/patient/*" element={<PatientRoutes />} />
      
      {/* Doctor Routes */}
      <Route path="/doctor/*" element={<DoctorRoutes />} />
      
      {/* Hospital Routes */}
      <Route path="/hospital/*" element={<HospitalRoutes />} />
      
      {/* Pharmacy Routes */}
      <Route path="/pharmacy/*" element={<PharmacyRoutes />} />
      
      {/* Admin Routes */}
      <Route path="/admin/*" element={<AdminRoutes />} />

      {/*Anbulance Routes*/}
      <Route path="/ambulance/*" element={<AmbulanceRoutes/>}/>
      
      {/* Shared Routes  */}
      <Route path="/shared/*" element={<SharedRoutes />} />
      
      {/* Public Routes */}
      <Route path="/*" element={<PublicRoutes />} />
    </Routes>
  );
};

export default AppRoutes;